export const JIRA_PROJECT_CREATED_WITH_WIZARD_KEY = 'jira_project_with_wizard';
